import { FieldValues, useController } from 'react-hook-form';

import AutocompleteBase from './AutocompleteBase';
import { AutocompleteFieldProps } from './types';
import useAutocompleteField from './useAutocompleteField';

export default function AutocompleteField<T extends FieldValues, ParsedType>({
  control,
  name,
  ...rest
}: AutocompleteFieldProps<T, ParsedType>) {
  const { field, fieldState } = useController({ control, name });
  const error = fieldState.error?.message ?? fieldState.error?.root?.message;

  const autocompleteState = useAutocompleteField();

  return (
    <AutocompleteBase
      error={error}
      inputValue={autocompleteState.inputValue}
      isOpen={autocompleteState.isOpen}
      name={name}
      onChange={field.onChange}
      onClose={autocompleteState.handleClose}
      onInputChange={autocompleteState.handleInputChange}
      onOpen={autocompleteState.handleOpen}
      value={field.value}
      {...rest}
    />
  );
}
